











import Component from "vue-class-component";
import StandardSearch from "front-component/components/SelectSearch.vue";
import _ from "lodash";
import {Vue, Prop, Watch} from "vue-property-decorator";
import EventBus from "front-component/EventBus";
import { Getter } from "vuex-class";
import { BudgetAllocation } from "@/modules/budget/BudgetAllocation";
import { Budget } from "@/modules/budget/Budget";
import moment from "moment";
import CsTreeSelect from "@/components/miscellaneous/CsTreeSelect.vue";

interface Node {
    id: string;
    uuid: string;
    label: string;
    value: string;
    children?: Node[];
}

@Component({ components: {CsTreeSelect, StandardSearch } })
export default class BudgetSearch extends Vue {
    private filterValue: string | null = null;
    @Prop() public value!: string;
    @Prop() public filterName!: string;

    @Getter("getBudgets") public budgets!: Budget[];
    @Getter("getBudgetAllocations") public budgetAllocations!: BudgetAllocation[];

    @Watch("value", { immediate: true })
    public updateValue(): void {
        this.filterValue = this.value;
        if (this.filterValue === "") {
            this.filterValue = null;
            EventBus.$emit("update-filter", _.set({}, this.filterName, ""));
        }
    }

    @Watch("filterValue") public onFilterChange(newValue: string): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, newValue));
    }

    get options(): Node[] {
        const nodes: Node[] = [];

        _.forEach(this.budgets, (budget: Budget) => {
            const node: Node = {
                id: budget.uuid,
                uuid: budget.uuid,
                label: budget.label + " (" + moment(budget.beginDate, "YYYYMMDD").format("YYYY") + ")",
                value: budget.uuid,
                children: [],
            };

            const newBudgetAllocations = this.budgetAllocations.filter((line: BudgetAllocation) => {
                return line.budget.uuid === budget.uuid;
            });
            newBudgetAllocations.sort((a, b) => a.label.localeCompare(b.label));

            _.forEach(newBudgetAllocations, (line: BudgetAllocation) => {
                if (line.budget.uuid === budget.uuid) {
                    node.children?.push({
                        id: line.uuid,
                        uuid: line.uuid,
                        label: line.label,
                        value: line.uuid,
                    });
                }
            });

            nodes.push(node);
        });

        return nodes;
    }
}
